import { Pipe, PipeTransform } from '@angular/core';
import { OrderedItem, IngredientChoiceGroup } from 'ngx-web-api';

@Pipe({
  name: 'invalidChoiceGroup',
})
export class InvalidChoiceGroupPipe implements PipeTransform {
  transform(item: OrderedItem, group: IngredientChoiceGroup): any {
    if (!item || !group) {
      return false;
    }
    return item.hasInvalidChoiceFor(group);
  }
}
